import { ConfigEntry } from '../services/config.service';

/**
 * Configuration for alterations (module changes, contract changes, cancellations)
 *
 * ⚠️ When changing default values, update the following docs:
 *   - docs/customer/aenderungen-beantragen.md
 *   - docs/customer/faq.md
 *   - docs/employee/admin-aktionen.md
 *   - docs/employee/vertragsaenderungen.md
 */
export const ALTERATIONS_CONFIG: ConfigEntry[] = [
  {
    key: 'MODULE_CHANGE_ALLOWED_MONTHS',
    value: [2, 8], // February = 2, August = 8 (1-based months)
    defaultValue: [2, 8],
    type: 'array',
    description: 'Erlaubte Monate für Modulwechsel (1-12, z.B. 2=Februar, 8=August)',
    searchTags: ['modulwechsel', 'monate', 'termine', 'halbjahr'],
    group: 'alterations',
  },
  {
    key: 'MODULE_CHANGE_ALLOWED_DAY',
    value: 1, // 1st of the month
    defaultValue: 1,
    type: 'number',
    description: 'Erlaubter Tag im Monat für Modulwechsel (1-31)',
    searchTags: ['modulwechsel', 'tag', 'termin'],
    group: 'alterations',
  },
  {
    key: 'MODULE_CHANGE_LOCKOUT_WEEKS',
    value: 6,
    defaultValue: 6,
    type: 'number',
    description: 'Sperrfrist vor Modulwechsel-Termin in Wochen',
    searchTags: ['modulwechsel', 'sperrfrist', 'lockout', 'wochen'],
    group: 'alterations',
  },
  {
    key: 'MODULE_CHANGE_MAX_FUTURE_OPTIONS',
    value: 5,
    defaultValue: 5,
    type: 'number',
    description: 'Maximale Anzahl zukünftiger Termine zur Auswahl',
    searchTags: ['modulwechsel', 'auswahl', 'termine'],
    group: 'alterations',
  },
  {
    key: 'CONTRACT_CHANGE_AUTO_APPROVE_MONTHS',
    value: 3,
    defaultValue: 3,
    type: 'number',
    description: 'Vertragsänderungen werden automatisch genehmigt, wenn sie X Monate im Voraus beantragt werden',
    searchTags: ['vertragsänderung', 'genehmigung', 'automatisch', 'monate'],
    group: 'alterations',
  },
];
